import { clsx } from '../../../lib/clsx';

import styles from './ParagraphSmallMedium.module.css';

import type { ParagraphProps } from './text.types';

export function ParagraphSmallMedium(props: ParagraphProps) {
  const { lineHeight, color, textAlign, className, style, children, ...rest } = props;

  return (
    <p
      {...rest}
      className={clsx(styles.root, className)}
      style={{
        '--prop-line-height': lineHeight,
        '--prop-color': color,
        ...style,
      }}
      data-text-align={textAlign}
    >
      {children}
    </p>
  );
}
